const SITE_URL = 'https://bigsport.com.ua';
const DEFAULT_IMAGE = `${SITE_URL}/logo-w512.png`;

const stripHtml = (html = '') => String(html || '')
  .replace(/<\/(p|div|h[1-6]|li|blockquote|section|article)>/gi, '$& ')
  .replace(/<[^>]*>/g, ' ')
  .replace(/&nbsp;|&#160;/gi, ' ')
  .replace(/&amp;/gi, '&')
  .replace(/&quot;/gi, '"')
  .replace(/&#39;|&apos;/gi, "'")
  .replace(/&lt;/gi, '<')
  .replace(/&gt;/gi, '>')
  .replace(/\s+/g, ' ')
  .trim();

const createDescription = (content = '', maxLength = 170) => {
  const text = stripHtml(content);
  if (!text) {
    return 'Останні спортивні новини України та світу на BigSPORT.';
  }
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1).trim()}…`;
};

const toIsoDate = (value) => {
  if (!value) return null;
  try {
    if (typeof value.toDate === 'function') {
      return value.toDate().toISOString();
    }
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date.toISOString();
  } catch {
    return null;
  }
};

const cleanObject = (value) => {
  if (Array.isArray(value)) {
    return value.map(cleanObject).filter(
      (item) => item !== undefined && item !== null && item !== ''
    );
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value)
        .map(([key, item]) => [key, cleanObject(item)])
        .filter(([, item]) => (
          item !== undefined
          && item !== null
          && item !== ''
          && !(Array.isArray(item) && item.length === 0)
        ))
    );
  }
  return value;
};

const getCategoryLink = (category) => {
  const categoryLinks = {
    'Футбол України': '/football-ukraine',
    Єврокубки: '/eurocups',
    Чемпіонати: '/championships',
    Біатлон: '/biathlon',
    'Види спорту': '/sports',
    Турніри: '/tournaments',
  };
  return categoryLinks[category] || null;
};

const resolveNewsImage = (news = {}) => (
  news.thumbnailURL
  || news.imageUrl
  || news.imageURL
  || news.image
  || news.mainImage
  || news.cover
  || news.thumbnail
  || news.media?.url
  || DEFAULT_IMAGE
);

const createNewsSeoData = (news, authorId = null) => {
  const canonicalUrl = `${SITE_URL}/news/${news.id}`;
  const description = createDescription(news.content || news.description);
  const image = resolveNewsImage(news);
  const datePublished = toIsoDate(news.publishedAt) || toIsoDate(news.timestamp);
  const dateModified = toIsoDate(news.updatedAt) || datePublished;
  const authorName = news.author || news.authorName || 'Редакція BigSPORT';
  const author = authorId
    ? {
        '@type': 'Person',
        name: authorName,
        url: `${SITE_URL}/profile/${authorId}`,
      }
    : {
        '@type': 'Person',
        name: authorName,
      };
  const categoryLink = getCategoryLink(news.category);
  const categoryUrl = categoryLink
    ? `${SITE_URL}${categoryLink}`
    : `${SITE_URL}/news`;

  const articleSchema = cleanObject({
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': canonicalUrl,
    },
    url: canonicalUrl,
    headline: news.title,
    description,
    image: [image],
    datePublished,
    dateModified,
    author,
    publisher: {
      '@type': 'NewsMediaOrganization',
      '@id': `${SITE_URL}/#organization`,
      name: 'BigSPORT',
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: DEFAULT_IMAGE,
      },
    },
    articleSection: news.category || 'Спорт',
    keywords: Array.isArray(news.tags) ? news.tags.join(', ') : undefined,
    inLanguage: 'uk-UA',
    isAccessibleForFree: true,
  });

  const breadcrumbSchema = cleanObject({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Головна',
        item: SITE_URL,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: news.category || 'Новини',
        item: categoryUrl,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: news.title,
        item: canonicalUrl,
      },
    ],
  });

  return {
    title: `${news.title} — BigSPORT`,
    description,
    image,
    canonicalUrl,
    datePublished,
    dateModified,
    articleSchema,
    breadcrumbSchema,
  };
};

module.exports = {
  SITE_URL,
  DEFAULT_IMAGE,
  cleanObject,
  createDescription,
  createNewsSeoData,
  getCategoryLink,
  resolveNewsImage,
  stripHtml,
  toIsoDate,
};
